import React, { useEffect } from 'react';
import { FormGroup, Label, Input, } from 'reactstrap';
import { omit, isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import { prefectures, } from '../../shared/config';
import { fieldDisplayValue, } from '../../shared/util';
import { generalSettingsFields } from '../../shared/models/tenant';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import SettingsTabs from '../SettingsTabs';

const { entries } = Object;

export default Page(function SettingsGeneral (props) {
  const { tenant } = props;
  const sendersRef = tenant.ref.collection('senders');
  const senders = useCollectionSubscription(sendersRef.orderBy('createdAt'), [tenant.id]);
  const fields = generalSettingsFields({ tenant, senders });
  const fieldsWithLabelHint = {
    ...fields,
  };

  return (
    <div className="settings-general container-fluid">
      <div className="p-4 bg-white my-4">
        <SettingsTabs activeTab="general" />
        <div className="d-flex justify-content-start mb-3">
          <EditButton itemRef={tenant.ref} FormModal={ModelFormModal} formProps={{ title: '一般設定', fields: fieldsWithLabelHint, fieldProps: _ => ({ documentName: 'tenant', }), }} />
        </div>
        <div className="mt-3">
          <table className="table table-bordered">
            <tbody>
              {
                entries(generalSettingsFields({ tenant, senders })).map(([fieldName, fieldSettings]) => {
                  const { label, initialValue, hidden = _ => false, } = fieldSettings;
                  const isHidden = hidden(tenant);
                  return !isHidden && (
                    <tr key={fieldName}>
                      <th className="table-secondary" style={{ minWidth: 400 }}>{label}</th>
                      <td style={{ whiteSpace: 'pre-line', minWidth: 400, }}>{fieldDisplayValue(tenant[fieldName] || initialValue, fieldSettings)}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});
